import gql from 'graphql-tag';

const GET_ALL_WORK_STATUSES = gql`
  query {
    getWorkStatuses {
      statusId
      name
      state
    }
  }
`;

export { GET_ALL_WORK_STATUSES };
